import * as React from 'react';
import {IOtpProps} from 'myshubhlife-component/form/FormInterfaceProps';
import Otp from 'myshubhlife-component/otp';

const OtpField = (props: IOtpProps) => {
  const handleOtp = (val) => {
    props.handleFormChange(val, props.index, 'otp');
    props.handleFormChange(val, props.index, 'value');
    props.handleFormChange('', props.index, 'errorMsg');
    props.handleFormChange('default', props.index, 'validated');
  }
  const resendOtp = () => {
    props.handleFormChange([], props.index, 'otp');
    props.handleFormChange([], props.index, 'value');
    props.handleFormChange(true, props.index, 'resend');
  }
  return (
    <div className="s-form-group-field">
      <Otp
        otp={props.field.otp || []}
        otpLength={props.field.otpLength}
        otpType={props.field.otpType}
        updateOtp= {handleOtp}
        resendOtp={resendOtp}
      />
      {props.field.errorMsg ?
        <div className="error-message flex-center-row">
            {props.field.errorMsg}
        </div> : null}
    </div>
  )
}

export default OtpField;